import { createContext, useContext, useState, type ReactNode } from 'react';

interface GameReadyContextValue {
  isGameReady: boolean;
  setIsGameReady: (value: boolean) => void;
}

const GameReadyContext = createContext<GameReadyContextValue>({
  isGameReady: false,
  setIsGameReady: () => {},
});

export function GameReadyProvider({ children }: { children: ReactNode }) {
  const [isGameReady, setIsGameReady] = useState(false);
  return (
    <GameReadyContext.Provider value={{ isGameReady, setIsGameReady }}>
      {children}
    </GameReadyContext.Provider>
  );
}

export function useGameReady() {
  return useContext(GameReadyContext);
}
